const validate = values => {
  const errors = {};

  if (!values.policyType) {
    errors.policyType = 'Policy type is required';
  }

  return errors;
};

export default validate;
